import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ApolloProvider } from 'react-apollo';
import MediaDataQuery from '../Query/MediaDataQuery';
import client from '../../graphql/client';
import MediaPlayer from '../mediaplayers/MediaPlayer';
import '../../styles/style.scss';

class App extends Component {
  static propTypes = {
    // Location object from React Router
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
  };

  state = {
    // required to load a video.
    id: null,
  };

  componentDidMount() {
    // this creates a new object based on the query string in the URL
    // so we can retrieve the parameters we need to load the app.
    const {
      location: { search },
    } = this.props;
    const searchParams = new URLSearchParams(search);

    this.setState({
      id: searchParams.get('id'),
    });
  }

  render() {
    const { id } = this.state;

    // Provide an error when there is no id in the current state.
    // Could have a better layout or message :)
    if (!id) {
      return <p style={{ textAlign: 'center' }}>Please provide an `id`.</p>;
    }

    // This root component has an <ApolloProvider/> that allows us to do
    // GraphQL queries and mutations.
    // Nested within this component is a <MediaDataQuery/> which will fetch
    // the video data required for the <VideoPlayer/>. Note that the <VideoPlayer/>
    // itself is not loading the data so it can be used as a standalone player.
    return (
      <ApolloProvider client={client}>
        <MediaDataQuery
          id={id}
          render={data => React.createElement(MediaPlayer, data)}
        />
      </ApolloProvider>
    );
  }
}

export default App;
